/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import arrowLeftBtn from '../../../assets/icons/arrow-btn-left.svg';
import arrowRightBtn from '../../../assets/icons/arrow-btn-right.svg';
import { getUITA } from '../../../utils/commonUtils';

export const ARROW_DIRECTION = {
  LEFT: 0,
  RIGHT: 1,
  UP: 2,
  DOWN: 3,
};

const useStyles = makeStyles({
  root: {
    cursor: 'pointer',
  },
  up: {
    transform: 'rotate(90deg)',
  },
  down: {
    transform: 'rotate(-90deg)',
  },
});

function ArrowButton({ direction, onClick = () => {} }) {
  const classes = useStyles();

  const arrowButton =
    direction === ARROW_DIRECTION.LEFT
      ? arrowLeftBtn
      : direction === ARROW_DIRECTION.RIGHT
      ? arrowRightBtn
      : arrowLeftBtn;

  return (
    arrowButton !== null && (
      <img
        className={classNames(
          classes.root,
          direction === ARROW_DIRECTION.UP
            ? classes.up
            : direction === ARROW_DIRECTION.DOWN
            ? classes.down
            : ''
        )}
        src={arrowButton}
        alt="Arrow Button"
        onClick={onClick}
        ui-ta={getUITA(
          'ThreePanelLayout',
          'ArrowButton',
          direction === ARROW_DIRECTION.LEFT ? 'left' : 'right'
        )}
      />
    )
  );
}

export default ArrowButton;
